module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion",
    class: {
      open: _vm.open
    }
  }, [_c('div', {
    staticClass: "accordion__header",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "accordion__content"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a582ffc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Accordion.vue
// module id = 9XK4
// module chunks = 1